import { NgModule } from '@angular/core';

const DIRECTIVES = [];

@NgModule({
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES],
})
export class DirectiveModule {}
